<template>
  <div v-if="media && content" class="image-text-lockup">
    <div class="row row--flex-col-mobile">
      <div class="image column sm-4">
        <a v-if="link" :href="link">
          <MediaImage
            :always-fill="true"
            :max-width="480"
            :media="media"
            :use-aspect="true"
          />
        </a>
        <MediaImage
          v-else
          :always-fill="true"
          :max-width="480"
          :media="media"
          :use-aspect="true"
        />
      </div>
      <div class="text column sm-8">
        <RichTextRenderer :document="content" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { InlineImageLockupStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: InlineImageLockupStoryblok
}>()
const media = computed(() =>
  props.blok.image && props.blok.image.filename ? props.blok.image : {},
)
const content = computed(() => props.blok.content)

// TODO - duplication - refactor all MultilinkStoryblok to use a shared component
const isExternalLink = computed(() => props.blok.link?.linktype === 'url')
const link = computed(() =>
  isExternalLink.value
    ? props.blok.link?.url
    : props.blok.link?.story
      ? '/' + props.blok.link.story.full_slug
      : '',
)
</script>

<style lang="less" scoped>
.image-text-lockup {
  margin: @gutter-lg 0;

  .image {
    margin: 0 0 @gutter-sm;

    @media @tablet {
      margin: 0;
    }
  }
}

@media print {
  .image-text-lockup {
    .row {
      flex-direction: row;

      > .sm-4 {
        flex-basis: 25%;
      }

      > .sm-8 {
        flex-basis: 75%;
      }
    }
  }
}
</style>
